import { useCallback, useMemo } from 'react'
import { useFetchPartners } from 'legacy/components/SelectPartnerWarehouse/queries/partners'

type PartnerOption = {
  label: string
  value: string
}
interface Props {
  onChange: (option: [PartnerOption]) => void
  useMultiSelect: boolean
}

export const useAccountManagementPartners = ({ onChange, useMultiSelect }: Props) => {
  const { partners, loading, error } = useFetchPartners()

  const options = useMemo(() => {
    if (!partners) return []

    return partners.map(partner => ({
      label: partner.name,
      value: partner.id.toString(),
    }))
  }, [partners])

  const onSelectChange = useCallback(
    value => {
      if (useMultiSelect) {
        onChange(value)
      } else {
        onChange([value])
      }
    },
    [onChange, useMultiSelect]
  )

  return {
    options,
    loading,
    error,
    onSelectChange,
    useMultiSelect,
  }
}
